module.exports = __webpack_public_path__ + "img/locked.33b38b42.png";